import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    marginBottom: 60,
  },

  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },

  logo: {
    width: 140,
    '@media (max-width: 1200px)': {
      width: 130,
    },
    '@media (max-width: 450px)': {
      width: 120,
    },
  },

  logoDimensa: {
    width: 100,
    '@media (max-width: 1200px)': {
      display: 'none',
    },
  },

  titleContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '2rem',
    '@media (max-width: 900px)': {
      justifyContent: 'center',
    },
    '& h2': {
      fontSize: '1.8rem',
      fontFamily: 'sans-serif',
      fontStyle: 'italic',
      '@media (max-width: 900px)': {
        display: 'none',
      },
    },
  },

  userInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    margin: 10,
    width: 220,

    '& > span': {
      fontSize: 14,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
  },

  drawerOpen: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
  },

  menuItem: {
    fontSize: '18px !important',
    color: '#000 !important',

    '&.Mui-selected': {
      color: '#ffffff !important',
      backgroundColor: `${Colors.primaryColor} !important`,
    },
  },

  navigation: {
    '@media (max-width: 900px)': {
      display: 'none',
    },
  },

  mobileNavigation: {
    '@media (min-width: 900px)': {
      display: 'none',
    },
  },

  outButton: {
    backgroundColor: Colors.headerColor,
    color: Colors.white,
    '& strong': {
      fontWeight: 800,
    },
  },
}))

export default styles
